import {
	Component,
	Input,
	OnInit,
	Output,
	ViewChild,
	ChangeDetectorRef,
	ChangeDetectionStrategy,
	EventEmitter,
	ElementRef
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ComponentService } from '../../../../../../services/component.service';
import { FileUploadManagerService } from '../services/fu-manager.service';
import { OverlayService } from '../../../../../../services/overlay.service';
import { FormPackage } from '../../dynamic-form/models/df-package';

import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';

@Component({
	selector: 'file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadComponent implements OnInit {
	@ViewChild('fileManagerModal', { static: false }) public fileManagerModal: ModalDirective;
	@Input() allowedType;
	// @Input() allowedDimensions;
	// @Input() optional;
	@Input() package: FormPackage;
	@Input() nestedFormControlKey?: string;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	@Input() index;
	@Output() configChange = new EventEmitter();
	@ViewChild('dropdownMenu', { static: true }) dropdownMenu: ElementRef;
	get inValidControl() {
		return this.config.get(this.package.key).hasError('required');
	}

	@Input() packageGroup?: FormGroup;
	get inValidGroup() {
		if (!this.packageGroup) {
			return false;
		}

		return (
			this.config.get(this.package.key).get('font').value === 'Custom Font' &&
			this.packageGroup.get(this.nestedFormControlKey).hasError('required')
		);
	}

	accept: string;
	pattern: string;
	filter: string;
	maxFileSize = Number(100);
	isModalShown = Boolean(false);
	isModalYoutubeShown = Boolean(false);
	modalHeight: string = window.innerHeight * 0.9 + 'px';
	importUrl: string;
	validYouTube = Boolean(false);
	fileBoxValues;
	fileURL;

	constructor(
		private comService: ComponentService,
		private files: FileUploadManagerService,
		private overlay: OverlayService,
		private ref: ChangeDetectorRef
	) {}

	ngOnInit() {
		if (this.package.type === 'fileBox') {
			var fileList = this.config.get(this.package.key).value;
			this.fileURL = fileList[this.index];
		}

		switch (this.allowedType) {
			case 'images': {
				this.accept = '.jpg,.jpeg,.gif,.png';
				this.pattern = '.jpg,.jpeg,.JPG,.JPEG,.gif,.GIF,.png,.PNG';
				this.filter = 'image';
				break;
			}

			case 'fonts': {
				this.accept = '.ttf,.otf';
				this.pattern = '.ttf,.TTF,.otf,.OTF';
				this.filter = 'font';
				break;
			}

			case 'videos': {
				this.accept = '.mp4';
				this.pattern = '.mp4,.MP4';
				this.filter = 'video';
				break;
			}

			case 'csv': {
				this.accept = '.csv';
				this.pattern = '.csv,.CSV';
				this.filter = 'csv';
				break;
			}

			default: {
				break;
			}
		}
	}

	hidedropMenu() {
		this.dropdownMenu.nativeElement.classList.remove('show');
	}

	uploadFile(event) {
		const fileList: FileList = event.target.files;
		if (fileList.length === 0) {
			return false;
		}
		const file: File = fileList[0];
		this.overlay.updateOverlay(true, 'Uploading file...');
		this.files.uploadFile(file).subscribe(
			(res) => {
				this.overlay.updateOverlay(false);
				if (res['status']) {
					this.updateFileUploadControl(res.data);
					this.ref.markForCheck();
				} else {
					this.overlay.updateOverlay(true, res['data'], 'alert');
				}
			},
			(err) => {
				this.overlay.updateOverlay(true, err, 'alert');
				this.comService.updateDisabledSave(false);
			}
		);
	}

	updateFileUploadControl(url?: string): boolean | null {
		if (!url) {
			return false;
		}

		if (this.package.type === 'fileBox') {
			var fileList = this.config.get(this.package.key).value;
			fileList[this.index] = url;
			this.config.get(this.package.key).patchValue(fileList);
		} else {
			if (this.packageGroup) {
				this.packageGroup.get(this.nestedFormControlKey).patchValue(url);
			} else {
				this.config.get(this.package.key).patchValue(url);
			}
		}
	}

	removeFile() {
		if (this.package.type === 'fileBox') {
			var fileList = this.config.get(this.package.key).value;
			fileList[this.index] = '';
			this.config.get(this.package.key).patchValue(fileList);
		} else {
			if (this.packageGroup) {
				this.packageGroup.get(this.nestedFormControlKey).patchValue('');
			} else {
				this.config.get(this.package.key).patchValue('');
			}
		}
	}

	handleOutput(event) {
		switch (event.method) {
			case 'selected': {
				this.fileManagerModal.hide();
				this.updateFileUploadControl(event.url);
				break;
			}

			default: {
				break;
			}
		}
	}

	cheackYouTubeValid() {
		this.validYouTube =
			this.importUrl.search('youtube.com') !== -1 && (this.importUrl.search('embed') !== -1 || this.importUrl.search('v=') !== -1);
	}

	importFile() {
		if (this.validYouTube) {
			this.updateFileUploadControl(this.importUrl);
			this.isModalYoutubeShown = false;
		}
	}
}
